import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

const FALLBACK_EMBED = 'https://player.vimeo.com/video/1169652030?autoplay=1&muted=1&loop=1&background=1';

// Convert a raw YouTube or Vimeo watch URL into an embeddable URL.
function toEmbedUrl(raw) {
  if (!raw?.trim()) return FALLBACK_EMBED;

  // Already an embed URL — use as-is
  if (raw.includes('player.vimeo.com') || raw.includes('/embed/')) return raw;

  // Vimeo: vimeo.com/123456789
  const vimeo = raw.match(/vimeo\.com\/(\d+)/);
  if (vimeo) {
    return `https://player.vimeo.com/video/${vimeo[1]}?autoplay=1&muted=1&loop=1&background=1`;
  }

  // YouTube: youtube.com/watch?v=ID  or  youtu.be/ID
  const yt = raw.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?/\s]+)/);
  if (yt) {
    return `https://www.youtube.com/embed/${yt[1]}?autoplay=1&mute=1&loop=1&playlist=${yt[1]}&controls=0&playsinline=1`;
  }

  // Unknown format — pass through and hope for the best
  return raw;
}

function Hero() {
  const [embedUrl, setEmbedUrl] = useState(FALLBACK_EMBED);
  const [ready, setReady]       = useState(false);

  useEffect(() => {
    async function fetchVideo() {
      const { data } = await supabase
        .from('settings')
        .select('value')
        .eq('key', 'video_url')
        .maybeSingle();
      setEmbedUrl(toEmbedUrl(data?.value));
      setReady(true);
    }
    fetchVideo();
  }, []);


  return (
    <section
      id="top"
      className="relative w-full overflow-hidden flex items-center justify-center"
      style={{ minHeight: '80vh' }}
    >
      {/* Full-bleed video background */}
      <div
        className="absolute"
        style={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100vw',
          height: '56.25vw',
          minHeight: '100%',
          minWidth: '177.78vh',
          pointerEvents: 'none',
        }}
        aria-hidden="true"
      >
        {ready && (
          <iframe
            src={embedUrl}
            title="Trivia Nights Live background video"
            className="w-full h-full"
            allow="autoplay; fullscreen; picture-in-picture"
            sandbox="allow-scripts allow-same-origin allow-presentation"
            style={{ border: 'none', pointerEvents: 'none' }}
          />
        )}
      </div>

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/10" aria-hidden="true" style={{ pointerEvents: 'none' }} />

      {/* Content */}
      <div
        className="relative z-10 w-full"
        style={{ padding: '5rem 2rem' }}
      >
        <h1
          className="font-boxen text-gold leading-tight whitespace-normal md:whitespace-nowrap"
          style={{
            fontSize: 'clamp(1rem, 3.5vw, 3rem)',
            display: 'block',
            width: '100%',
            margin: '0 auto',
            textAlign: 'center',
            letterSpacing: '0.05em',
          }}
        >
          EAT. DRINK.<br className="md:hidden" /> ANSWER QUESTIONS.
        </h1>
      </div>
    </section>
  );
}

export default Hero;
